import React from 'react'

const AppLinks = () => <div className='appLinks'>{/*<h1>App Links</h1>*/}</div>

export default AppLinks
